var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{attrs:{"color":"navContent","icon":""},on:{"click":function($event){_vm.showSearchDialog = true}}},[_c('v-icon',[_vm._v("mdi-magnify")])],1),_c('app-bar-search-dialog',{model:{value:(_vm.showSearchDialog),callback:function ($$v) {_vm.showSearchDialog=$$v},expression:"showSearchDialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }